module.exports = __webpack_public_path__ + "img/img3.6ae2c128.png";